import { Result } from '@empathy/search-types';
import { isArrayEmptyOrNull } from './is-empty';

export function mapWishlistToResults(wishlist: string[], results: Result[]) {
  if (!isArrayEmptyOrNull(wishlist)) {
    results.forEach(result => {
      result.isWishlisted = wishlist.includes(result.id);
    });
  }
}
